import { render, staticRenderFns } from "./Riskverification.vue?vue&type=template&id=4ac67967"
import script from "./Riskverification.vue?vue&type=script&lang=js"
export * from "./Riskverification.vue?vue&type=script&lang=js"
import style0 from "./Riskverification.vue?vue&type=style&index=0&id=4ac67967&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports